/**
 * Texts of the Accueil page header (design `accueil.entete`) — config, never
 * inline JSX strings. The tiles and the banner own their texts in their own
 * config files (they are registered, overridable components).
 */

import type { ExtranetPerson } from '../../auth/types';

export const HOME_TEXT = {
  /** « Bienvenue, {prénom} » — the comma is only added when a name is known. */
  welcome: 'Bienvenue',
  subtitle: 'Voici un aperçu de votre espace client professionnel.',
} as const;

const HOME_DATE_FORMATTER = new Intl.DateTimeFormat('fr-FR', {
  weekday: 'long',
  day: 'numeric',
  month: 'long',
  year: 'numeric',
});

/**
 * Today's date line of the Accueil (`fr-FR`, long weekday + month), in the
 * browser's timezone — « jeudi 11 juin 2026 » (shown upper-case by CSS).
 */
export function formatHomeDate(date: Date): string {
  return HOME_DATE_FORMATTER.format(date);
}

/** First name of the welcome line: `prenom`, else `nom`, else `''`. */
export function welcomeNameOf(person: ExtranetPerson | null | undefined): string {
  const prenom = person?.prenom?.trim() ?? '';
  if (prenom !== '') return prenom;
  return person?.nom?.trim() ?? '';
}
